import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { Fraction } from '../../types/Fees'
import Amount from '../Amount'

const Row = styled.div`
  display: flex;
  justify-content: stretch;
  height: 40px;
  & > div {
    font-size: 14px;
    padding-left: 16px;
    line-height: 40px;
  }
`

const Name = styled.div`
  flex: 0;
  flex-basis: 50%;
`

const Percent = styled.div`
  flex: 111;
`

const DiscountAmount = styled.div`
  flex: 108;
`

const Action = styled.div`
  flex: 104;
  display: flex;
  justify-content: flex-end;
`

type Props = {
  name: string
  rate: Fraction
  total?: number
  unit?: string
  actions?: React.ReactNode
}

const DiscountRow = ({ name, rate, total, unit, actions }: Props) => (
  <Row>
    <Name>{name}</Name>
    <Percent>
      ({Math.round((100 * rate.numerator) / rate.denominator)} %)
    </Percent>
    <DiscountAmount>
      {!!total && !!unit ? (
        <Amount
          amount={-(total * rate.numerator) / rate.denominator}
          unit={unit}
        />
      ) : (
        <FormattedMessage id="notApplicable" />
      )}
    </DiscountAmount>
    <Action>{actions}</Action>
  </Row>
)

export default DiscountRow
